import { Translate } from "components/common/Translate/Translate";
import type { Color } from "store/features/colorPicker/types";
import { ColorCard } from "./ColorCard/ColorCard";
import { useColorScheme } from "./useColorScheme";

export interface ColorSchemeProps {
    colors: Color[] | Color;
    label: string;
}

export const ColorScheme = ({ colors, label }: ColorSchemeProps) => {
    const { source, handleCopyAll } = useColorScheme(colors);
    return (
        <div className="flex flex-col gap-6 cursor-grab pr-4">
            <div className="grid grid-cols-3 lg:grid-cols-4 gap-4" data-testid={`color-cards-container`}>
                {Array.isArray(colors) ? (
                    colors.map((color, idx) => <ColorCard key={idx} hex={color.hex} source={source} />)
                ) : (
                    <ColorCard hex={colors.hex} source={source} />
                )}
            </div>
            <div className="text-irGray-600 dark:text-darkSurface-600 text-lg">
                {label}
                {Array.isArray(colors) && (
                    <span
                        className="cursor-pointer underline-offset-2 underline px-2 whitespace-nowrap capitalize font-semibold dark:text-white"
                        onClick={handleCopyAll}
                        data-testid={`color-scheme-copy-all-button`}
                    >
                        <Translate keyName="copy-all" />
                    </span>
                )}
            </div>
        </div>
    );
};
